import { isToolbarSaveAsActive } from './ToolbarStore';

export const updateToolbarSaveAs = (value) => isToolbarSaveAsActive.update((oldValue) => value);
